import { ReactNode, ReactElement, useState } from 'react'
import { Translate } from 'src/i18n'
import styled from 'styled-components'
import { MessageBoxTitleBar } from './MessageBoxTitleBar'
import { MessageBoxType } from '../Interfaces'

interface MessageBoxProps {
  title: string
  closeText: string
  children: ReactNode
  show: boolean
  type?: MessageBoxType
}

export const MessageBox = (props: MessageBoxProps): ReactElement | null => {
  const {
    title,
    closeText,
    children,
    show,
    type = MessageBoxType.WARNING,
  } = props
  const [showMessage, setShowMessage] = useState(show)
  if (!showMessage) {
    return null
  }
  const isErrorTypeOfUnavaliabilty = MessageBoxType.ERROR === type

  return (
    <MessagesBoxWrapper isErrorTypeOfUnavaliabilty={isErrorTypeOfUnavaliabilty}>
      <MessageBoxTitleBar
        titleText={Translate(title)}
        closeText={closeText}
        onClose={() => setShowMessage(false)}
        type={type}
      />
      {children}
    </MessagesBoxWrapper>
  )
}

MessageBox.defaultProps = {
  closeText: 'dismiss',
}

interface MessagesHeaderProps {
  isErrorTypeOfUnavaliabilty: boolean
}

const MessagesBoxWrapper = styled.div<MessagesHeaderProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  background: ${(p) => p.theme.colors.componentsBackground};
  border: 1.5px solid
    ${(p) =>
      p.isErrorTypeOfUnavaliabilty
        ? p.theme.colors.dangerAlertBgBorder
        : p.theme.colors.primary};
  box-sizing: border-box;
  border-radius: 3px;
`
